import { defaultShouldDehydrateQuery, QueryClient } from "@tanstack/react-query";

/**
 * Create this inside getRouter so server requests never share a data cache.
 * Protected Convex data reaches the browser only through guarded Atlas
 * handlers, so the browser carries no Convex client.
 */
export function createAtlasQueryClient() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 0,
        // SSR keeps results until hydration; the router integration clears the
        // request cache afterwards. Browser subscriptions end on unmount.
        gcTime: typeof window === "undefined" ? Infinity : 0,
        retry: false,
      },
      mutations: { retry: false },
      dehydrate: {
        shouldDehydrateQuery: (query) =>
          query.meta?.ssr !== false && defaultShouldDehydrateQuery(query),
      },
    },
  });

  return { queryClient };
}

export type AtlasQueryContext = ReturnType<typeof createAtlasQueryClient>;
